<template>
  <div id="FactSheetPage" class="section">
    <div class="columns is-multiline has-text-left">
      <div class="column is-10-desktop is-12-tablet is-12-mobile">
        <h1 class="title">USER MANAGER</h1>
        <h1
          v-if="display_list && display_list.length > 0"
          class="subtitle is-6"
        >
          Total {{ display_list.length }} rows founds
        </h1>
      </div>
      <div class="column is-10-desktop is-12-tablet is-12-mobile">
        <b-field>
          <b-input
            placeholder="Search by Username, Name ,or Email..."
            type="search"
            icon="magnify"
            icon-clickable
            @input="filterUserList"
          >
          </b-input>
        </b-field>
      </div>
      <div
        v-if="user_profile.role === 'admin' || user_profile.role === 'ceo'"
        class="column is-2-desktop is-12-tablet is-12-mobile"
      >
        <b-button
          expanded
          type="is-primary"
          icon-left="plus"
          @click.prevent="presentCreateUserForm()"
        >
          New User
        </b-button>
      </div>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">{{ agent_count }}</p>
          <p class="subtitle">Total Agent</p>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">{{ manager_count }}</p>
          <p class="subtitle">Total Manager</p>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">{{ admin_count }}</p>
          <p class="subtitle">Total Admin</p>
        </article>
      </div>
    </div>
    <div class="container">
      <div v-if="display_list">
        <b-table striped hoverable :data="display_list">
          <template slot-scope="props">
            <b-table-column field="name" label="Name" sortable>
              {{ props.row.name }}
            </b-table-column>

            <b-table-column field="email" label="Email / Username" sortable>
              {{ props.row.email }}
            </b-table-column>

            <b-table-column
              field="business_unit_name"
              label="Business Unit"
              sortable
            >
              {{
                props.row.business_unit_name
                  ? props.row.business_unit_name
                  : "-"
              }}
            </b-table-column>

            <b-table-column field="role" label="Role" sortable>
              <b-tag v-if="props.row.role === 'ceo'" type="is-primary">
                <b>{{ props.row.role.toUpperCase() }} </b>
              </b-tag>
              <b-tag v-else-if="props.row.role === 'admin'" type="is-danger">
                <b>{{ props.row.role.toUpperCase() }} </b>
              </b-tag>
              <b-tag v-else-if="props.row.role === 'manager'" type="is-warning">
                <b>{{ props.row.role.toUpperCase() }} </b>
              </b-tag>
              <b-tag v-else type="is-info">
                <b>{{ props.row.role.toUpperCase() }} </b>
              </b-tag>
            </b-table-column>

            <b-table-column field="action" label="Action" width="220">
              <div class="buttons">
                <b-button
                  outlined
                  size="is-small"
                  type="is-primary"
                  icon-left="pencil"
                  @click="presentResetPasswordByAdminForm(props.row)"
                >
                  Reset Password
                </b-button>
                <b-button
                  outlined
                  size="is-small"
                  type="is-primary"
                  icon-right="account-edit"
                  @click="presentUpdateUserForm(props.row)"
                />
                <b-button
                  outlined
                  size="is-small"
                  type="is-danger"
                  icon-right="delete"
                  @click="presentRemoveUserForm(props.row)"
                />
              </div>
            </b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon
                    size="is-large"
                    type="is-primary"
                    icon="emoticon-sad-outline"
                  />
                </p>
                <p>No any user here!.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
      <div v-else>
        <section class="hero is-medium">
          <div class="hero-body">
            <div class="container">
              <h2 class="title is-4">Loading...</h2>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Helpers from "@/utils/Helper";
import UserApi from "@/services/UserApi";
import BusinessUnitApi from "@/services/BusinessUnitApi";

import AlertManager from "@/utils/AlertManager";
import CreateNewUserForm from "@/components/forms/CreateNewUserForm.vue";
import ResetPasswordForm from "@/components/forms/ResetPasswordForm.vue";

export default {
  name: "UsersPage",
  data() {
    return {
      display_list: null,
      userList: null,
      business_unit_list: []
    };
  },
  computed: {
    ...mapState(["user_profile"]),
    agent_count: function() {
      if (this.userList) {
        return this.userList.filter(user => user.role === "agent").length;
      }
      return 0;
    },
    manager_count: function() {
      // `this` points to the vm instance
      if (this.userList) {
        return this.userList.filter(user => user.role === "manager").length;
      }
      return 0;
    },
    admin_count: function() {
      // `this` points to the vm instance
      if (this.userList) {
        return this.userList.filter(user => user.role === "admin").length;
      }
      return 0;
    }
  },
  filters: {
    dateformatter: function(value) {
      if (!value) return "";
      return Helpers.dateFormatter(value);
    }
  },
  methods: {
    filterUserList: function(value) {
      const lowercase_value = value.toLowerCase();
      let filtered = this.userList.filter(function(user) {
        return (
          (user.name && user.name.toLowerCase().includes(lowercase_value)) ||
          (user.email && user.email.toLowerCase().includes(lowercase_value))
        );
      });
      this.display_list = filtered;
    },
    presentCreateUserForm: function() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: CreateNewUserForm,
        props: { mode: "create" },
        events: {
          create_success: () => {
            this.requestGetUserList();
          }
        }
      });
    },
    presentUpdateUserForm: function(user_info) {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: CreateNewUserForm,
        props: { mode: "edit", selected_user: user_info },
        events: {
          create_success: () => {
            this.requestGetUserList();
          }
        }
      });
    },
    presentResetPasswordByAdminForm: function(user_info) {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: ResetPasswordForm,
        props: {
          profile: user_info
        }
      });
    },
    presentRemoveUserForm: function(user_info) {
      this.$buefy.dialog.prompt({
        title: "Confirm Remove User",
        message:
          "Are you sure you want to permanently remove user <b>" +
          user_info.username +
          "</b>  of <b>" +
          user_info.name +
          "</b> from the system?",
        inputAttrs: {
          type: "text",
          placeholder: "type " + user_info.username + " here..."
        },
        confirmText: "Remove",
        trapFocus: true,
        closeOnConfirm: false,
        onConfirm: (value, { close }) => {
          if (value === user_info.username) {
            this.requestRemoveUser(user_info._id);
          } else {
            close();
            AlertManager.showErrorSnackbar("Input not match with user name");
          }
        }
      });
    },
    navigateToFactSheetDetail: function(selected) {
      this.$router.push({
        name: "factsheet-detail",
        query: { id: selected._id }
      });
    },
    requestGetUserList: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await UserApi.requestUserList();
      loadingComponent.close();
      if (response.status) {
        response.payload.forEach(element => {
          if (element.business_unit) {
            const found = Helpers.mappingBusinessUnitById(
              this.business_unit_list,
              element.business_unit
            );
            element.business_unit_name = found.business_unit_name;
          }
        });
        this.userList = response.payload;
        this.display_list = response.payload.reverse();
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    },
    requestRemoveUser: async function(user_id) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await UserApi.requestRemoveUserInfoById(user_id);
      loadingComponent.close();
      if (response.status) {
        this.requestGetUserList();
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    },
    requestGetBusinessUnitList: async function() {
      const response = await BusinessUnitApi.requestBusinessUnitList();
      if (response.status) {
        this.business_unit_list = response.payload;
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    }
  },
  async beforeMount() {
    await this.requestGetBusinessUnitList();
    await this.requestGetUserList();
  }
};
</script>
<style scoped>
.rounded {
  border-radius: 0.75rem;
}
</style>
